import { faChevronDown } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Dropdown = ({ label, options, value, setValue, title, disabled }) => (
  <div className="relative">
    <label className="block text-xs font-medium mb-1 ml-1">{label}</label>
    <select
      className="appearance-none rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 hover:cursor-pointer disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400 w-full"
      disabled={disabled}
      title={title}
      value={value}
      onChange={(event) => setValue(event.target.value)}
    >
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
    <div className="absolute top-[50%] right-0 pr-2">
      <FontAwesomeIcon
        aria-hidden="true"
        className="h-4 w-4 text-gray-400"
        icon={faChevronDown}
      />
    </div>
  </div>
)

export default Dropdown
